import { render, staticRenderFns } from "./KeyFiguresHandler.vue?vue&type=template&id=0c2678ac&scoped=true"
import script from "./KeyFiguresHandler.vue?vue&type=script&lang=js"
export * from "./KeyFiguresHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2678ac",
  null
  
)

export default component.exports